import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarClock, ArrowRight } from 'lucide-react';
import { formatCurrency } from '../lib/api';

const UpcomingBillsBanner = ({ bills }) => {
  const navigate = useNavigate();
  if (!bills || bills.length === 0) return null;

  const total = bills.reduce((s, b) => s + b.amount, 0);
  const next = bills[0];

  const daysLabel = (n) => {
    if (n < 0) return 'in ritardo';
    if (n === 0) return 'scade oggi';
    if (n === 1) return 'scade domani';
    return `tra ${n} giorni`;
  };

  return (
    <div
      data-testid="upcoming-bills-banner"
      className="rounded-xl border border-amber-200/80 dark:border-amber-900/40 bg-amber-50 dark:bg-amber-950/30 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4"
    >
      <div className="w-11 h-11 rounded-xl bg-amber-100 dark:bg-amber-900/50 flex items-center justify-center shrink-0">
        <CalendarClock className="w-5 h-5 text-amber-700 dark:text-amber-400" />
      </div>
      <div className="flex-1">
        <p className="font-semibold text-amber-900 dark:text-amber-200">
          {bills.length === 1 ? '1 fattura in arrivo' : `${bills.length} fatture in arrivo`}
          <span className="font-normal text-amber-800/80 dark:text-amber-300/80">
            {' · '}{formatCurrency(total)} totali
          </span>
        </p>
        <p className="text-sm text-amber-800/90 dark:text-amber-300/90">
          Prossima: <span className="font-medium">{next.name}</span> ({formatCurrency(next.amount)}) {daysLabel(next.days_until_due)}.
        </p>
      </div>
      <button
        onClick={() => navigate('/recurring')}
        className="text-sm font-medium text-amber-900 dark:text-amber-200 hover:underline whitespace-nowrap inline-flex items-center"
        data-testid="view-bills-btn"
      >
        Gestisci <ArrowRight className="w-4 h-4 ml-1" />
      </button>
    </div>
  );
};

export default UpcomingBillsBanner;
